import type { TickerItem, Persona, Step, UseCase, Customer, NavLink } from '../types'

export const NAV_LINKS: NavLink[] = [
  { label: 'How it works', id: 'how-it-works' },
  { label: "Who it's for", id: 'who-its-for' },
  { label: 'Pricing',      id: 'pricing' },
]

export const TICKER_ITEMS: TickerItem[] = [
  { emoji: '💇', label: 'Reply received',           text: '— Sarah M. replied "booking now!"' },
  { emoji: '☕', label: 'Customer returned',        text: '— James booked after 60 days away' },
  { emoji: '🧘', label: 'Membership reactivated',  text: '— Emma re-joined her studio' },
  { emoji: '💻', label: 'Reply received',           text: '— "Would love to work together again"' },
  { emoji: '🐾', label: 'Booking confirmed',        text: "— Max's grooming appointment locked in" },
  { emoji: '🛠️', label: 'Repeat job won',           text: '— Old client replied within 10 minutes' },
  { emoji: '💇', label: 'Appointment booked',       text: '— Lapsed client back after 8 weeks' },
  { emoji: '☕', label: 'New reply',                text: '— "Coming in tomorrow, thanks!"' },
]

export const PERSONAS: Persona[] = [
    { emoji: '🌱', label: 'Solo operators' },
    { emoji: '🏪', label: 'Local businesses' },
    { emoji: '📈', label: 'Growing brands' },
    { emoji: '🤝', label: 'Service businesses' },
    { emoji: '💼', label: 'Freelancers' },
    { emoji: '🚀', label: 'Early-stage startups' },
]

export const STEPS: Step[] = [
  {
    step: '01',
    emoji: '✍️',
    title: 'Create your free account',
    desc: 'Sign up in 2 minutes. Add your business name, what you offer, and your contact email. No credit card required.',
  },
  {
    step: '02',
    emoji: '📋',
    title: 'Upload your customer list',
    desc: 'Export a CSV from your booking system, Square, or spreadsheet and upload it. Nudge reads names, emails, and last-visit dates automatically.',
  },
  {
    step: '03',
    emoji: '⏱️',
    title: 'Set your lapse window',
    desc: 'Choose what "gone too long" means for your business — 30, 45, or 60 days. One setting. That\'s it. Nudge watches from here.',
  },
  {
    step: '04',
    emoji: '💌',
    title: 'Watch customers come back',
    desc: 'When someone goes quiet, Nudge sends a warm personal email in your voice — automatically. Replies land straight in your inbox.',
  },
]

export const USE_CASES: UseCase[] = [
  {
    emoji: '💇',
    title: 'Salon & Spa',
    desc: "Bring back clients who haven't rebooked after their last appointment.",
    stat: 'Avg. 3 clients/week returned',
  },
  {
    emoji: '☕',
    title: 'Café & Bakery',
    desc: "Remind your loyalty members who haven't visited in weeks.",
    stat: 'Perfect for loyalty regulars',
  },
  {
    emoji: '🧘',
    title: 'Yoga Studio',
    desc: 'Re-activate members before they cancel entirely.',
    stat: 'Reduce churn before it starts',
  },
  {
    emoji: '🐾',
    title: 'Pet Services',
    desc: "A gentle reminder when it's been too long since their last groom.",
    stat: 'Seasonal re-booking made easy',
  },
  {
    emoji: '💻',
    title: 'Freelancers',
    desc: 'Follow up with past clients at the perfect moment to land repeat projects.',
    stat: 'Land repeat work effortlessly',
  },
  {
    emoji: '🛠️',
    title: 'Local Services',
    desc: 'Remind past customers you exist before they search Google.',
    stat: 'Stay top-of-mind, always',
  },
]

export const CUSTOMERS: Customer[] = [
  {
    emoji: '👩',
    name: 'Sarah M.',
    sub: 'Last visit: Jan 14',
    tag: '68d away',
    bg: '#fecaca',
    color: '#dc2626',
  },
  {
    emoji: '👨',
    name: 'James T.',
    sub: 'Last visit: Feb 3',
    tag: '45d away',
    bg: '#fef3c7',
    color: '#d97706',
  },
  {
    emoji: '👩‍🦱',
    name: 'Priya K.',
    sub: 'Replied yesterday',
    tag: 'Coming back ✓',
    bg: '#dcfce7',
    color: '#15803D',
  },
]

export const SOCIAL_PROOF_AVATARS = ['👩‍🦰', '👨‍🍳', '🧘‍♀️', '👩‍💻', '🐾'] as const
